import React from 'react';

import styled from 'styled-components';
import { Button } from 'shared/components';
import { ItemsUnavailableDataType } from 'src/components/modals/items-unavailable';

type ItemsUnavailableProps = {
  close: () => void;
  data: ItemsUnavailableDataType;
};

// Component to display unavailable items in the cart
export const ItemsUnavailable = ({ close, data }: ItemsUnavailableProps): JSX.Element => (
  <Container>
    <Header>Item(s) Unavailable</Header>
    <p>Some items in your cart are no longer available. Check below to see what has changed.</p>
    <div>
      {data.failedCartItems.map((item) => (
        <Item key={item.id}>
          <ItemName>{item.name ?? 'Unknown Item'}</ItemName>
          <Table>
            <tbody>
              <tr>
                <th scope='row'>Previously in Cart:</th>
                <td>{item.quantity}</td>
              </tr>
              <tr>
                <th scope='row'>Amount Available:</th>
                <td>
                  {item.quantityAvailable && item.quantityAvailable > 0 ? (
                    <LowStock>{item.quantityAvailable}</LowStock>
                  ) : (
                    <OutOfStock>Out of Stock</OutOfStock>
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
        </Item>
      ))}
    </div>
    <Button onClick={close}>View Cart</Button>
  </Container>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: left;
`;

const Header = styled.p`
  font-size: 20px;
  font-weight: bold;
`;

const Item = styled.div`
  padding: 20px 0;
  border-top: 1px solid #d4dade;
`;

const ItemName = styled.p`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
`;

const Table = styled.table`
  border-spacing: 0 3px;
  th {
    font-weight: normal;
    width: 164px;
  }
  td {
    padding: 0;
  }
`;

const LowStock = styled.span`
  height: fit-content;
  background-color: #ffe83e;
`;

const OutOfStock = styled.span`
  color: #920715;
  height: fit-content;
  background-color: #fae8ea;
`;
